<div class="d-flex h-100">

  <div class="row  align-self-center col-md-6">
    ecomatrix.io &#160;LLC All Rights Reserved
  </div>

  <nav id="chartnav" class="navbar navbar-expand-sm  col-md-6">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a target="_blank" class="nav-link" href="http://www.ecomatrix.io/contact-us/">Contact Us</a>
      </li>
      <li class="nav-item">
        <a  class="nav-link disabled" href="#">Privacy Policy</a>
      </li>
      <li class="nav-item">
        <a class="nav-link disabled" href="#">Terms of Use</a>
      </li>
      <li class="nav-item">
        <a class="nav-link disabled" href="#">Compliance</a>
      </li>
      <li class="nav-item">
        <a class="nav-link disabled" href="#">Blog & Press</a>
      </li>
    </ul>

  </nav>

</div>